// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2016 Minted Inc.
 * All Rights Reserved
 * CTAG:COMMUNITY
 */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/moment.min.js': 'moment',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community': []
})(this, function (m_module, Backbone, $, moment, _) {
  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};

  M.Community.View.Comment = Backbone.View.extend({
    template: M.Template.Community.Comment,
    className: 'Comment',

    initialize: function() {
      M.required(this.options.designId);
      M.required(this.options.commentsUrlPath);
      M.required(this.options.count);
      
      this.collectionModels = [];
      this.collectionOptions = {
        commentsUrlPath: this.options.commentsUrlPath
      };

      this.collection = new M.Community.Collection.CommentList(
          this.collectionModels,
          this.collectionOptions
      );
      _.bindAll(this, '_setModelAndRender', '_renderErrorMessage',
          'fetchCommentDataAndRender');
    },

    render: function(numberOfResponses) {
      var templateVars = {
        'numberOfResponses': numberOfResponses
      };
      _.extend(templateVars, this.currentModel);
      this.$el.html(this.template(templateVars));

      return this;
    },

    fetchCommentDataAndRender: function() {
      var that = this;
      if (this.collection.length == 0) {
        this.collection.fetch({
          data: {
            design_id: that.options.designId,
            count: that.options.count,
            include_feedback_request_msg: false
          },
          success: function(collection, response) {
            var numberOfResponses = response.length;
            that._setModelAndRender(numberOfResponses);
          },
          error: function() {
            that._renderErrorMessage();
          }
        });
      } else {
        this._setModelAndRender();
      }
    },

    _setModelAndRender: function(numberOfResponses) {
      this.currentModel = [];
      for (var i = 0; i < numberOfResponses; i++){
        this.currentModel.push(this.collection.shift());
      }

      if (this.currentModel.length != 0) {
        this.render(numberOfResponses);
      } else {
        this._renderNoComments();
      }
    },

    _renderNoComments: function () {
      this.$el.html('<p class="text--light">No comments yet for this design. ' +
          'Be the first one to comment</p>');
    },

    _renderErrorMessage: function() {
      this.$el.html('<p class="text--light">Something went wrong while loading comments. ' +
          'Please try again later.</p>');
    }
  });

  return {};

});